export default "__VITE_ASSET__6qKQ0Snz__"